import { SxProps, Theme } from "@mui/material/styles";

export const statisticBoxStyle: SxProps<Theme> = (theme) => ({
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(0),
    position: "relative",
    fontFamily: "HsvSlab",
    zIndex: 1,
});

export const statisticNameStyle: SxProps<Theme> = (theme) => ({
    color: theme.palette.text.secondary,
    fontSize: "1.2rem",
    fontFamily: "HsvSlab",
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
    textTransform: "uppercase",
});

export const statisticValueStyle: SxProps<Theme> = (theme) => ({
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: "2.8rem",
    fontFamily: "HsvSlab",
    marginBottom: theme.spacing(1),
});

export const statisticDescriptionStyle: SxProps<Theme> = (theme) => ({
    color: theme.palette.text.secondary,
    fontFamily: "HsvSans",
    fontSize: "0.8rem",
    marginBottom: theme.spacing(2),
});

export const dividerStyle: SxProps<Theme> = (theme) => ({
    width: "100%",
    maxWidth: "150px",
});
